import { normalizeStringForSelectFilter } from './normalize-string';
export const filterOption = (inputValue, selectOption) => {
    if (selectOption === undefined)
        return false;
    const normalizedInputValue = normalizeStringForSelectFilter(inputValue);
    const normalizedOptionLabel = normalizeStringForSelectFilter(selectOption.label);
    return normalizedOptionLabel.startsWith(normalizedInputValue);
};
